"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var index_1 = require("../Icon/index");
var index_2 = require("../../contexts/index");
var BubblesDesktopTop_1 = require("../../icons/components/BubblesDesktopTop");
var BubblesTabletTop_1 = require("../../icons/components/BubblesTabletTop");
var BubblesMobileTop_1 = require("../../icons/components/BubblesMobileTop");
var index_3 = require("../FlexGrid/index");
var index_4 = require("../Box/index");
var BubbleTop = function () {
    var responsiveSize = react_1.useContext(index_2.ResponsiveContext);
    var getDesktopTopBubbles = function (breakpoint) {
        switch (breakpoint) {
            case 'xs':
                return BubblesMobileTop_1.BubblesMobileTop;
            case 'sm':
                return BubblesTabletTop_1.BubblesTabletTop;
            case 'md':
            case 'lg':
                return BubblesDesktopTop_1.BubblesDesktopTop;
            default:
                return BubblesDesktopTop_1.BubblesDesktopTop;
        }
    };
    return (react_1.default.createElement(index_3.FlexGrid, { direction: "column", wrap: "nowrap", alignItems: "center", margin: "none" },
        react_1.default.createElement(index_4.Box, { style: {
                overflow: 'none',
                alignItems: 'center',
                overflowX: 'hidden'
            } },
            react_1.default.createElement(index_1.Icon, { icon: getDesktopTopBubbles(responsiveSize), id: "TopBubble" }))));
};
exports.BubbleTop = BubbleTop;
//# sourceMappingURL=BubbleTop.js.map